module.exports = __webpack_public_path__ + "media/images/athletes/1825-6b9a0f34d3b7eebd51089836353d6823.png";